module.exports = __webpack_public_path__ + "img/头盔.44973b01.png";